export const getDisplayDate = (dateString) => {
    if (!dateString) return "N.A";
    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";
  
    const options = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    };
  
    return date.toLocaleString("en-IN", options);
  };
  